import {
    Text,
    View,
    StyleSheet,
    Image,
    Font,
} from "@react-pdf/renderer";
import Logo from '../../../assets/img/icon.png'
const styles = StyleSheet.create({
    textlg: {
        fontFamily: 'Open Sans',
        fontSize: 18,
        fontWeight: 600
    }, textmd: {
        fontSize: 16
    },
    textsm: {
        fontSize: 14
    },
    textxs: {
        fontSize: 12
    },
})
Font.register({
    family: 'Open Sans',
    fonts: [
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 },
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-800.ttf', fontWeight: 800 }
    ]
});
const KopSurat = () => (<View style={{ flexDirection: "row", padding: "0 15 10 15" }} >
    <Image src={Logo} style={{ width: "20%", marginLeft: 10 }} />
    <View style={{ width: "100%", textAlign: "center", paddingTop: 20, paddingLeft: 100 }}>
        <Text style={[styles.textlg]}>KOPILIBRASI</Text>
        <Text style={[styles.textxs]}>JL. Taruna Raya RT.18/04 Blok B No.8</Text>
        <Text style={[styles.textxs]}>Semper Barat, Cilincing, Jakarta Utara</Text>
    </View>
</View>)
export default KopSurat